import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numeroTelefonoSeparado'
})
export class NumeroTelefonoSeparadoPipe implements PipeTransform
{

  transform(value: any): any
  {
    // Verificar si el valor es un número de 9 dígitos
    if (typeof value === 'number' && value.toString().length === 9 || value.length === 9)
    {
      // Convertir el número a una cadena y separarlo en grupos de 3 dígitos
      const numeroSeparado = value.toString().replace(/(\d{3})(\d{3})(\d{3})/, '$1 · $2 · $3');
      return numeroSeparado;
    } else
    {
      return value; // Devolver el valor original si no es un número de 9 dígitos
    }
  }
}
